/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SpoMainPageComponent} from './spo-main-page.component';
import {RouterModule} from '@angular/router';
import {SpoListModule} from './spo-list/spo-list.module';

@NgModule({
    declarations: [
        SpoMainPageComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        SpoListModule
    ],
    exports: [SpoMainPageComponent]
})
export class SpoMainPageModule {
}
